// extracted by mini-css-extract-plugin
export var image = "LookingForMore-module--image--dcc46";
export var zebraImage = "LookingForMore-module--zebra-image--a5212";